var render = function render(){var _vm=this,_c=_vm._self._c;return _c('text-input',{attrs:{"name":"zip","label":_vm.label,"meta":""}})
}
var staticRenderFns = []

export { render, staticRenderFns }